import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import SeasonAnnouncement from './components/SeasonAnnouncement';
import AboutSection from './components/AboutSection';
import NewsSection from './components/NewsSection';
import SponsorsSection from './components/SponsorsSection';
import SocialMediaSection from './components/SocialMediaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <SeasonAnnouncement />
      <AboutSection />
      <NewsSection />
      <SponsorsSection />
      <SocialMediaSection />
    </div>
  );
}
